import React from 'react';

interface CourtMandateWarningProps {
  title: string;
  description: string;
  reference?: string;
  severity?: 'error' | 'warning';
  onRevert?: () => void;
  onAcceptRisk?: () => void;
  acceptLabel?: string;
}

const CourtMandateWarning: React.FC<CourtMandateWarningProps> = ({
  title,
  description,
  reference,
  severity = 'warning',
  onRevert,
  onAcceptRisk,
  acceptLabel = 'Accept Risk & Save',
}) => {
  const isError = severity === 'error';

  return (
    <div
      className={`mt-2 rounded-md border p-3 text-sm ${
        isError
          ? 'border-rose-300 bg-rose-50 text-rose-800 dark:border-rose-700 dark:bg-rose-900/20 dark:text-rose-200'
          : 'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-200'
      }`}
    >
      <p className="font-semibold">{title}</p>
      <p className="mt-1">{description}</p>
      {reference && <p className="mt-1 text-xs opacity-90">Reference: {reference}</p>}

      {(onRevert || onAcceptRisk) && (
        <div className="mt-3 flex flex-wrap gap-2">
          {onRevert && (
            <button
              type="button"
              onClick={onRevert}
              className="rounded-md border border-current px-2.5 py-1 text-xs font-medium hover:bg-white/40 dark:hover:bg-black/20"
            >
              Revert
            </button>
          )}
          {onAcceptRisk && (
            <button
              type="button"
              onClick={onAcceptRisk}
              className="rounded-md bg-current px-2.5 py-1 text-xs font-medium text-white hover:opacity-90"
            >
              {acceptLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default CourtMandateWarning;

